<template>
  <div>
    <!--面包蟹-->
    <div class="container integralBreadcrumb"
         style="height: 40px; line-height: 40px;color: #999">
      <i class="iconfont icon-ziyuan"></i>&nbsp;
      <span class="font_link_fw">
        <router-link :to="{name: 'home'}">首页</router-link>
      </span> &nbsp;&nbsp;>&nbsp;&nbsp;
      <router-link :to="{name: 'planList'}">解决方案</router-link> &nbsp;&nbsp;>&nbsp;&nbsp;
      <span><b>{{$route.query.title}}</b></span>
    </div>
    <!--banner-->
    <!--<div class="block banner" style="height: 150px;"></div>-->
    <!--列表-->
    <div class="container topMargin">
      <div style="text-align: center; margin-top: 40px; margin-bottom: 40px"
           v-show="$route.query.title === '安全管理'">
        <img src="/static/img/aquan.jpg"
             border="0"
             usemap="#Map"
             style="text-align: center">
        <map name="Map"
             id="Map">
          <router-link to="/planContent?title=安全管理&key=安全-园区安全应急联动"><area shape="rect"
                  coords="266,8,521,61" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-重大危险源监测预警"> <area shape="rect"
                  coords="544,4,807,63" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-环境因素监测预警"><area shape="rect"
                  coords="829,5,1086,57" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-SES中控安全监管和指挥系统"><area shape="rect"
                  coords="264,72,532,125" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-应急预案"><area shape="rect"
                  coords="543,70,802,123" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-人员定位"><area shape="rect"
                  coords="825,68,1092,121" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-仿真培训-OTS操作员仿真培训"><area shape="rect"
                  coords="263,160,534,210" /></router-link>
          <area shape="rect"
                coords="546,161,812,212"
                @click="open()" />
          <router-link to="/planContent?title=安全管理&key=安全-报警管理-先进报警管理系统"><area shape="rect"
                  coords="825,163,1086,211" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-作业管理"> <area shape="rect"
                  coords="262,221,533,273" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-智能巡检"><area shape="rect"
                  coords="546,224,811,274" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-变更管理"><area shape="rect"
                  coords="827,222,1083,274" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-日常安全管理"><area shape="rect"
                  coords="266,284,671,335" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-系统雷击防护-中控防雷服务"> <area shape="rect"
                  coords="683,285,1083,339" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-安全仪表系统"><area shape="rect"
                  coords="265,346,390,395" /></router-link>
          <area shape="rect"
                coords="405,346,528,398"
                @click="open()" />
          <area shape="rect"
                coords="547,347,671,457"
                @click="open()" />
          <router-link to="/planContent?title=安全管理&key=安全-远程诊断维护"><area shape="rect"
                  coords="684,346,815,457" /></router-link>
          <area shape="rect"
                coords="824,346,954,459"
                @click="open()" />
          <area shape="rect"
                coords="966,347,1088,457"
                @click="open()" />
          <router-link to="/planContent?title=安全管理&key=安全-系统内建安全"><area shape="rect"
                  coords="266,406,529,453" /></router-link>
          <area shape="rect"
                coords="273,487,458,545"
                @click="open()" />
          <router-link to="/planContent?title=安全管理&key=安全-风险评估--工艺危险分析(HAZOP)"><area shape="rect"
                  coords="475,488,671,546" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-保护层规划--SIL评估"><area shape="rect"
                  coords="686,488,881,543" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-信息安全健康诊断与防御"><area shape="rect"
                  coords="892,487,1093,540" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-功能安全管理--综述"><area shape="rect"
                  coords="190,12,235,538" /></router-link>
          <router-link to="/planContent?title=安全管理&key=安全-信息安全管理"><area shape="rect"
                  coords="1119,10,1170,531" /></router-link>
        </map>
      </div>
      <!--//环保-->
      <div style="text-align: center; margin-top: 40px; margin-bottom: 40px"
           v-show="$route.query.title === '环保管理'">
        <img src="/static/img/huanbao.jpg"
             border="0"
             usemap="#Map1"
             style="text-align: center">
        <map name="Map1"
             id="Map1">
          <router-link to="/planContent?title=环保管理&key=环保-边界废气监测-厂界VOCs在线监测解决方案"><area shape="rect"
                  coords="188,285,356,339" /></router-link>
          <router-link to="/planli?title=环保管理&title1=废水/气检测"><area shape="rect"
                  coords="630,684,774,793" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-废水_气治理-VOCs治理解决方案"><area shape="rect"
                  coords="938,682,1078,794" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-固废智能监管-固废智能监管解决方案"><area shape="rect"
                  coords="632,559,1077,670" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-环保优化设计-VOCs循环化解决方案"><area shape="rect"
                  coords="9,641,156,711" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-环境风险管理-环境风险管理解决方案"><area shape="rect"
                  coords="730,7,1121,127" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-环境事故联动-环境事故联动解决方案"><area shape="rect"
                  coords="734,388,1071,458" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-环境事故预警-环境事故预警解决方案"><area shape="rect"
                  coords="731,222,1070,296" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-环境效益管理-环境效益管理解决方案"><area shape="rect"
                  coords="368,71,720,122" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-环境影响评估-环境影响评估解决方案"><area shape="rect"
                  coords="11,559,156,628" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-节能减排-VOCs治理效率优化解决方案"><area shape="rect"
                  coords="166,682,315,735" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-空气质量监测-空气监测站解决方案"><area shape="rect"
                  coords="191,347,360,399" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-末端治理设计-VOCs治理解决方案"><area shape="rect"
                  coords="9,723,155,797" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-区域废气监测-微型空气站解决方案"><area shape="rect"
                  coords="191,222,357,275" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-人员应急预警-人员应急预警解决方案_1"><area shape="rect"
                  coords="912,304,1072,376" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-生产环境监测-危险气体监测网络解决方案"><area shape="rect"
                  coords="476,558,620,789" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-生态园区-生态园区解决方案"><area shape="rect"
                  coords="12,225,179,337" /></router-link>
          <router-link to="/planli?title=环保管理&title1=实验室分析"><area shape="rect"
                  coords="162,742,314,795" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-视情维修-汽轮机视情维修解决方案"><area shape="rect"
                  coords="166,559,314,611" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-污染排放管理-污染排放管理解决方案"><area shape="rect"
                  coords="371,9,719,60" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-泄露与修复-泄露检测与修复（LDAR）解决方案"><area shape="rect"
                  coords="165,620,313,674" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-移动监测-移动监测解决方案"><area shape="rect"
                  coords="373,223,540,462" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-移动应急预警-移动应急预警解决方案"><area shape="rect"
                  coords="732,305,899,375" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-污染溯源-园区大气污染溯源解决方案"><area shape="rect"
                  coords="549,223,721,457" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-治理设施监测-治理设施监测解决方案"><area shape="rect"
                  coords="783,684,922,791" /></router-link>
          <router-link to="/planli?title=环保管理&title1=智慧环保"><area shape="rect"
                  coords="15,7,355,126" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-环保e院-'环保e院'解决方案"><area shape="rect"
                  coords="12,346,179,463" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-废水监测-区域水质在线监测解决方案"><area shape="rect"
                  coords="191,409,359,460" /></router-link>
          <router-link to="/planContent?title=环保管理&key=环保-节能减排-锅炉焚烧效率优化解决方案"><area shape="rect"
                  coords="328,560,463,789" /></router-link>
        </map>
      </div>
      <!--//生产-->
      <div style="text-align: center; margin-top: 40px; margin-bottom: 40px"
           v-show="$route.query.title === '生产管理'">
        <img src="/static/img/shengchan.jpg"
             border="0"
             usemap="#Map2"
             style="text-align: center">
        <map name="Map2"
             id="Map2">
          <area shape="rect"
                coords="191,10,341,62"
                @click="open()" />
          <router-link to="/planContent?title=生产管理&key=生产管控-生产监控"><area shape="rect"
                  coords="356,9,517,64" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-生产计量"><area shape="rect"
                  coords="527,9,686,65" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-生产统计"><area shape="rect"
                  coords="695,8,856,64" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-物料平衡"><area shape="rect"
                  coords="870,10,1024,61" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-罐区管理"><area shape="rect"
                  coords="189,71,344,123" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-调度管理"><area shape="rect"
                  coords="357,72,515,125" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-生产计划"><area shape="rect"
                  coords="526,73,684,125" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-标准任务"><area shape="rect"
                  coords="697,72,854,124" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-实验室管理"><area shape="rect"
                  coords="868,67,1025,123" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控 - 操作管理"> <area shape="rect"
                  coords="187,131,344,186" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-工艺管理"><area shape="rect"
                  coords="359,133,513,182" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控 - 库存管理"> <area shape="rect"
                  coords="528,130,685,184" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控 - 辅料管理"><area shape="rect"
                  coords="697,132,855,185" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控 - 计量体系"><area shape="rect"
                  coords="868,130,1026,183" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-批量配方管理"><area shape="rect"
                  coords="188,192,459,245" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-制造工单管理"><area shape="rect"
                  coords="469,193,738,242" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-条码系统管理"><area shape="rect"
                  coords="757,191,1025,241" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-生产批次管理"><area shape="rect"
                  coords="190,253,457,304" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-PDA移动操作"><area shape="rect"
                  coords="471,251,743,302" /></router-link>
          <router-link to="/planContent?title=生产管理&key=生产管控-批次工艺分析"><area shape="rect"
                  coords="759,252,1024,302" /></router-link>
          <area shape="rect"
                coords="189,334,605,390"
                @click="open()" />
          <area shape="rect"
                coords="616,335,1020,388"
                @click="open()" />
          <router-link to="/planContent?title=生产管理&key=生产管控-装置全流程控制优化一体化解决方案"><area shape="rect"
                  coords="186,399,607,455" /></router-link>
          <area shape="rect"
                coords="626,399,1028,460"
                @click="open()" />
          <area shape="rect"
                coords="186,463,604,516"
                @click="open()" />
          <area shape="rect"
                coords="628,464,1023,522"
                @click="open()" />
          <area shape="rect"
                coords="185,527,598,586"
                @click="open()" />
          <area shape="rect"
                coords="618,528,1025,586"
                @click="open()" />
        </map>
      </div>
      <!--//设备-->
      <div style="text-align: center; margin-top: 40px; margin-bottom: 40px"
           v-show="$route.query.title === '设备管理'">
        <img src="/static/img/shebei.jpg"
             border="0"
             usemap="#Map3"
             style="text-align: center">
        <map name="Map3"
             id="Map3">
          <router-link to="/planContent?title=设备管理&key=设备管理-设备隐患管理"><area shape="poly"
                  coords="156,273,166,332,38,401,13,254" /></router-link>
          <router-link to="/planContent?title=设备管理&key=设备管理-设备远程维护管理"><area shape="poly"
                  coords="253,405,311,404,362,541,205,540" /></router-link>
          <router-link to="/planContent?title=设备管理&key=设备管理-移动作业和综合巡检"><area shape="poly"
                  coords="190,191,150,248,18,215,94,90" /></router-link>
          <router-link to="/planContent?title=设备管理&key=设备管理-设备档案与资产管理"><area shape="poly"
                  coords="417,270,400,334,525,410,550,247" /></router-link>
          <router-link to="/planContent?title=设备管理&key=设备管理-设备知识库"><area shape="poly"
                  coords="173,354,230,404,175,526,53,430" /></router-link>
          <router-link to="/planContent?title=设备管理&key=设备管理-设备综合分析"><area shape="poly"
                  coords="259,11,122,64,215,175,271,155" /></router-link>
          <area shape="poly"
                coords="380,357,336,399,393,528,512,431"
                @click="open()" />
          <router-link to="/planContent?title=设备管理&key=设备管理-设备维护管理"> <area shape="poly"
                  coords="352,175,295,147,298,12,439,66" /></router-link>
          <router-link to="/planContent?title=设备管理&key=设备管理-设备监控与数据采集"><area shape="poly"
                  coords="471,90,544,220,413,247,378,192"
                  href="#" /></router-link>
        </map>
      </div>
      <!--//能源-->
      <div style="text-align: center; margin-top: 40px; margin-bottom: 40px"
           v-show="$route.query.title === '能源优化'">
        <img src="/static/img/nengyuan.jpg"
             border="0"
             usemap="#Map4"
             style="text-align: center">
        <map name="Map4"
             id="Map4">
          <router-link to="/planContent?title=能源优化&key=能源_氢气平衡与优化"><area shape="rect"
                  coords="749,157,994,211" /></router-link>
          <router-link to="/planContent?title=能源优化&key=能源_蒸汽平衡与优化"> <area shape="rect"
                  coords="247,158,477,210"></router-link>
          <router-link to="/planContent?title=能源优化&key=能源_瓦斯平衡与优化"><area shape="rect"
                  coords="493,158,737,213" /></router-link>
          <router-link to="/planContent?title=能源优化&key=能源-大数据分析"><area shape="rect"
                  coords="493,393,739,447" /></router-link>
          <router-link to="/planContent?title=能源优化&key=能源-能耗基准管理"><area shape="rect"
                  coords="248,331,480,386" /></router-link>
          <router-link to="/planContent?title=能源优化&key=能源-能流监控"><area shape="rect"
                  coords="247,242,616,301" /></router-link>
          <router-link to="/planContent?title=能源优化&key=能源-能效监控"><area shape="rect"
                  coords="626,244,993,300" /></router-link>
          <router-link to="/planContent?title=能源优化&key=能源-能源计划预测"><area shape="rect"
                  coords="492,334,739,385" /></router-link>
          <router-link to="/planContent?title=能源优化&key=能源-能源绩效评估"><area shape="rect"
                  coords="247,393,481,446" /></router-link>
          <router-link to="/planContent?title=能源优化&key=能源-能源实绩分析"><area shape="rect"
                  coords="753,334,994,383" /></router-link>
          <router-link to="/planContent?title=能源优化&key=能源-能源总览"><area shape="rect"
                  coords="243,70,485,124" /></router-link>
          <router-link to="/planContent?title=能源优化&key=能源-指标查询"><area shape="rect"
                  coords="500,72,735,125" /></router-link>
          <router-link to="/planContent?title=能源优化&key=能源-指标地图"><area shape="rect"
                  coords="754,71,998,122" /></router-link>
          <router-link to="/planContent?title=能源优化&key=能源-能源统计报表"><area shape="rect"
                  coords="751,393,994,446" /></router-link>
          <area shape="rect"
                coords="248,8,997,58"
                @click="open()" />
        </map>
      </div>
      <!--//供应链-->
      <div style="text-align: center; margin-top: 40px; margin-bottom: 40px"
           v-show="$route.query.title === '供应链优化'">
        <img src="/static/img/gongying.jpg"
             border="0"
             usemap="#Map5"
             style="text-align: center">
        <map name="Map5"
             id="Map5">
          <router-link to="/planContent?title=供应链优化&key=供应链-仓库管理"><area shape="rect"
                  coords="959,8,1088,61" /></router-link>
          <router-link to="/planContent?title=供应链优化&key=供应链-成品油调合"><area shape="rect"
                  coords="545,9,671,62" /></router-link>
          <router-link to="/planContent?title=供应链优化&key=供应链-罐区管理"><area shape="rect"
                  coords="827,9,955,63" /></router-link>
          <router-link to="/planContent?title=供应链优化&key=供应链-油品移动"><area shape="rect"
                  coords="403,8,533,63" /></router-link>
          <router-link to="/planContent?title=供应链优化&key=供应链-原油调合"><area shape="rect"
                  coords="267,9,392,62" /></router-link>
          <router-link to="/planContent?title=供应链优化&key=供应链-终端自动化"><area shape="rect"
                  coords="684,9,814,61" /></router-link>
          <area shape="rect"
                coords="265,93,1089,566"
                @click="open()" />
        </map>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'planList',
  data () {
    return {}
  },
  methods: {
    open () {
      this.$alert('正在建设中', '提示', {
        confirmButtonText: '确定'
      })
    }
  }
}
</script>

<style scoped>
.banner {
  background: url("/static/img/jjbanner.jpg") no-repeat top center;
}

.planListbox {
  margin-top: 30px;
  margin-bottom: 30px;
  background: #f7f7f7;
}

.planListTitle {
  font-size: 20px;
  margin: 25px 0px 20px 0px;
}

.planListCon {
  font-size: 14px;
  line-height: 25px;
  color: #999;
}

.el-button--medium {
  padding: 14px 40px;
  font-size: 14px;
  border-radius: 30px;
  margin: 10px 20px 0px 20px;
  background: #3195c5;
  color: #fff;
}
.topMargin {
  margin-top: 30px;
}
.font_link_fw a {
  color: #666;
}
.font_link_fw a:hover {
  color: #666;
}
</style>
